const envMode = "prod";
const devRootUrl = "http://localhost:3001/d2c";
const prodRootUrl = "https://api.labormart.in/d2c";
const rootUrl = envMode === "development" ? devRootUrl : prodRootUrl;

export default rootUrl;
